import React from 'react';
import { Modal, Container, Button } from 'react-bootstrap';
import { CDBIcon } from 'cdbreact';


export const isLimitError = (errorMessage) => {
  if (!errorMessage || typeof errorMessage !== 'string') return false;
  const lowerMsg = errorMessage.toLowerCase();

  const isAmountExceeded =
    lowerMsg.includes('monto supera el máximo permitido') ||
    (lowerMsg.includes('monto supera') && lowerMsg.includes('3,500'));
  const isDailyExceeded =
    lowerMsg.includes('límite transaccional diario') ||
    (lowerMsg.includes('transaccional diario') && lowerMsg.includes('5,000'));
  const isMonthlyExceeded =
    lowerMsg.includes('límite transaccional mensual') ||
    (lowerMsg.includes('transaccional mensual') && lowerMsg.includes('50,000'));

  return isAmountExceeded || isDailyExceeded || isMonthlyExceeded;
};

export const LimitErrorModal = ({ show, message, onClose }) => {
  if (!show) return null;

  const formattedMessage = message
    ? message.charAt(0).toUpperCase() + message.slice(1)
    : '';

  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Body style={{ padding: '24px' }}>
        <Container style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <CDBIcon icon="exclamation-circle" size="7x" style={{ color: '#F1C901' }} />
        </Container>
        <br />
        <Container>
          <h4
            className="fw-bold"
            style={{
              textAlign: 'center',
              color: '#3E3E3E',
              lineHeight: '1.5',
              fontSize: '1.25rem',
              margin: '0 auto'
            }}
          >
            {formattedMessage}
          </h4>
        </Container>
        <br />
        <Container style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <Button
            variant="primary"
            style={{
              background: '#0E9600',
              borderColor: '#0E9600',
              padding: '8px 30px',
              borderRadius: '6px'
            }}
            onClick={onClose}
          >
            <div className="fw-bold h5 mb-0">Aceptar</div>
          </Button>
        </Container>
      </Modal.Body>
    </Modal>
  );
};

export default LimitErrorModal;
